<template lang="">
  <div class="mains">
    <div class="container">
      <div class="header_title">溯源字段设定</div>
      <div class="top">
        <Button class="newBotton" @click="inAddVal()">
          <span class="newBottonText">新增</span>
        </Button>
        <div class="select">
          <Input v-model="selectVal" @on-search="select()" search placeholder="输入流水号" />
        </div>
        <div class="select" style="line-height:35px">
          共 {{allPage}} 条记录
        </div>
      </div>
      <div class="main mains">
        <el-empty description="没有数据哦！" v-if="pageData.length == 0" />
        <Table
          border
          :columns="columns"
          :data="pageData"
          style="width: 100%"
          v-if="pageData.length !== 0"
        >
          <!-- <Table border :columns="columns" :data="datas" style="width:100%;"> -->
          <template #name="{ row }">
            <strong>{{ row.name }}</strong>
          </template>
          <template #start="{ row, index }">
            <span v-if="row.start == 1" style="color: green">已启用</span>
            <span v-if="row.start == 0" style="color: red">未启用</span>
          </template>
          <template #action="{ row, index }">
            <Button style="margin-right: 5px" @click="show(index)">修改</Button>
            <Button type="error" @click="remove(index)">删除</Button>
          </template>
        </Table>
        <!-- 分页 -->
        <Page
          class="page"
          :modelValue="pages"
          :total="allPage"
          simple
          @on-change="page"
        />
      </div>

      <Drawer
        title="修改赋码资料"
        :closable="false"
        v-model="value"
        width="600"
      >
        <updataAssign
          :AssignDatas="pageData[SelectIndex]"
          @updataAssignResult="closeUpdataAssign"
        ></updataAssign>
      </Drawer>
      <Drawer
        title="添加赋码资料"
        :closable="false"
        v-model="addVal"
        width="600"
      >
        <NewAssign @CloseAssign="CloseAssigns"></NewAssign>
      </Drawer>
    </div>
  </div>
</template>
<script>
import NewAssign from "@/views/AssignList/NewAssign";
import updataAssign from "@/views/AssignList/updataAssign";
import { GetAssignList, DelAssignList } from "@/api/index";
export default {
  data() {
    return {
      selectVal: "",
      value: false,
      addVal: false,
      columns: [
        {
          title: "id",
          key: "id",
          width: 65,
        },
        {
          title: "企业代码",
          key: "clientCode",
          width: 120,
        },
        {
          title: "字段ID",
          key: "filedId",
          width: 200,
        },
        {
          title: "开始流水号",
          key: "minSerial",
          width: 200,
        },
        {
          title: "结束流水号",
          key: "maxSerial",
          width: 200,
        },
        {
          title: "备注",
          key: "remark",
          width: 200,
        },
        {
          title: "添加时间",
          key: "time",
          minWidth: 200,
        },
        {
          title: "状态",
          slot: "start",
          key: "start",
          width: 100,
        },
        {
          title: " ",
          slot: "action",
          width: 170,
          align: "center",
          fixed: "right",
        },
      ],
      // 源数据
      datas: [],
      // 搜索后的数据
      inData: [],
      // 分页后的数据
      pageData: [],
      inDatas: {
        inCode: "",
        inName: "",
        inWrite: "",
        inDate: "",
      },
      pages: 1,
      allPage: 1,
      SelectIndex: "",
    };
  },
  components: {
    NewAssign,
    updataAssign,
  },
  watch: {},
  created() {
    let control = this.$store.state.control;
    if (control !== "1") {
      this.columns = this.columns.filter((p, key) => {
        if (p.title !== "企业代码") {
          return p;
        }
      });
    }
    this.getAssign()
  },
  methods: {
    select() {
      this.getAssign()
    },
    // 获取企业资料
    getAssign() {
      GetAssignList({
        code: 1,
        page: this.pages,
        pagesize: 10,
        name: this.selectVal,
      }).then((res) => {
        this.pageData = res.list;
        this.allPage = res.size;
      });
    },

    CloseAssigns() {
      this.getAssign()
      this.addVal = false;
    },

    inAddVal(index) {
      this.addVal = true;
    },
    // 点击修改执行
    show(index) {
      this.SelectIndex = index;
      this.value = true;
    },
    // 删除按钮
    remove(index) {
      const title = this.pageData[index].filedId;
      const code = this.pageData[index].clientCode;
      const id = this.pageData[index].id;
      this.$confirm("此操作将永久删除该" + title + "字段, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 提交删除请求
          DelAssignList({
            id,
          }).then((res) => {
            if (res.code == 402) {
              this.$Notice.error({ title: "没有权限！" });
            }
            if (res == 1) {
              this.getAssign()
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败！",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭修改侧边栏
    closeUpdataAssign() {
      this.getAssign()
      this.value = false;
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      this.getAssign()
    },
    // 接收来自子组件的回值---添加信息
    // async addClientList(value) {
    //   this.datas.push(value);
    // },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
